import {DiscountBannerProducts} from '@aboutyou/grpc-clients/tadarida/aysa_api/models//discount_banner_products.types';
import {
  Button,
  COLORS,
  FONT_SIZES,
  FONT_WEIGHTS,
  GenericIconName,
  Icon,
  ProductImage,
  UnstyledLink,
  useGetAriaLabelFromUrl,
} from '@aboutyou/ui-components';
import React from 'react';
import styled from 'styled-components';

export const DiscountCardThumbnails = ({
  color = COLORS.Black,
  discountBannerProducts,
}: {
  color?: string;
  discountBannerProducts: DiscountBannerProducts;
}) => {
  const getAriaLabelFromUrl = useGetAriaLabelFromUrl();
  return (
    <ThumbnailsContainer data-testid="cardThumbnails">
      {discountBannerProducts.images.map((image, index) => (
        <ThumbnailContainer
          key={index}
          to={discountBannerProducts.cta.linkTarget.url}
          aria-label={getAriaLabelFromUrl(
            discountBannerProducts.cta.linkTarget.url,
          )}
        >
          <ProductImage
            src={image.src}
            alt={image.description}
            padded={image.isEnclosed}
            ratio={'3:3'}
          />
        </ThumbnailContainer>
      ))}
      <StyledButton
        $fontColor={color}
        variant="secondary"
        size="md"
        href={discountBannerProducts.cta.linkTarget.url}
        aria-label={undefined}
      >
        {discountBannerProducts.cta.label}
        <StyledArrowIcon
          data-testid="cardThumbnailsCta"
          fill={color}
          asset={GenericIconName.ArrowLongRight}
          size="XSS"
        />
      </StyledButton>
    </ThumbnailsContainer>
  );
};

const ThumbnailsContainer = styled.div`
  display: flex;
  width: 100%;
  opacity: 0;
  position: absolute;
  bottom: 0;
  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  animation: fadeIn 0.5s;
  animation-fill-mode: forwards;
  animation-delay: 0.5s;
`;

const ThumbnailContainer = styled(UnstyledLink)`
  box-sizing: border-box;
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${COLORS.Grey4};
  border-radius: 3px;
  margin-right: 6px;
`;

const StyledButton = styled(Button)<{$fontColor?: string}>`
  &&&& {
    flex: 1;
    max-width: unset;
    min-height: 32px;
    height: auto;
    padding: 7px 12px;
    font-size: ${FONT_SIZES.px12};
    font-weight: ${FONT_WEIGHTS.w400};
    --color: ${({$fontColor}) => $fontColor};
  }
`;

const StyledArrowIcon = styled(Icon)<{fill?: string}>`
  margin-left: 4px;
  &&&& {
    fill: ${({fill}) => fill};
  }
`;
